import React, { useState, useEffect } from 'react'
import { activate } from '../../../api/userAPI'
import { useDispatch } from 'react-redux'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { loginHandler } from '../../../redux/auth/authSlice'
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CFormLabel,
  CInputGroup,
  CRow,
} from '@coreui/react'
import SpinnerDefault from 'src/components/SpinnerDefault'
import { ReCaptcha, loadReCaptcha } from 'react-recaptcha-google'
import logo from '../../../assets/images/logo_principal.png'
import './styles.scss'

const Login = () => {
  let navigate = useNavigate()
  const dispatch = useDispatch()
  const [email, setEmail] = useState()
  const [password, setPassword] = useState()
  const [accountStatus, setAccountStatus] = useState('done')
  const [searchParams, setSearchParams] = useSearchParams()
  const [message, setMessage] = useState()
  const [captchaToken, setCaptchaToken] = useState('')
  const [showSpin, setShowSpin] = useState(false)
  let captchaDemo = ''

  useEffect(() => {
    //loadReCaptcha()
    let name = searchParams.get('activetoken')
    const sendActivation = async (token) => {
      setShowSpin(true)
      try {
        const response = await activate(token)
        setShowSpin(false)
        setAccountStatus('active')
        console.log(response)
        setMessage(
          <div className="alert alert-success text-center">
            <span>{response.data.message}</span>
          </div>,
        )
        setTimeout(() => {
          setAccountStatus('done')
          setMessage('')
        }, 5000)
      } catch (err) {
        setShowSpin(false)
        setMessage(
          <div className="container">
            <div className="alert alert-danger text-center">{err.response.data.message}</div>
          </div>,
        )
        setTimeout(() => {
          setAccountStatus('done')
          setMessage('')
        }, 5000)
        setAccountStatus('failed')
      }
    }
    if (name) {
      setAccountStatus('activating')
      setMessage(
        <div className="alert alert-info text-center">
          <span>Por favor aguarde, seu usuários está sendo ativado</span>
        </div>,
      )
      sendActivation(name)
    } else {
      setAccountStatus('done')
    }
  }, [searchParams])

  const forgotPassword = () => {
    navigate('/forgot')
  }

  const onLoadRecaptcha = () => {
    if (captchaDemo) {
      captchaDemo.reset()
      captchaDemo.execute()
    }
  }
  const verifyCallback = (recaptchaToken) => {
    setCaptchaToken(recaptchaToken)
  }

  const onClickLogin = async (event) => {
    event.preventDefault()
    setShowSpin(true)
    const creds = {
      email,
      password,
      captchaToken,
    }

    try {
      dispatch(loginHandler(creds))
        .then(async (result) => {
          if (result.error) {
            setShowSpin(false)
            if (result.error.code === 'ERR_BAD_REQUEST') {
              console.log(result.error)
              setMessage(
                <div className="container">
                  <div className="alert alert-danger text-center">
                    Por favor, tente novamente mais tarde
                  </div>
                </div>,
              )
            }
          } else {
            setShowSpin(false)
            if (result.payload.role === 'admin') {
              navigate('/selectcompany')
            } else {
              navigate('/dashboard')
            }
          }
        })
        .catch((e) => console.log('boom', e))
    } catch (error) {
      //navigate('/login')
      console.log(error)
      setMessage(
        <div className="container">
          <div className="alert alert-danger text-center">{error.response.data.message}</div>
        </div>,
      )
      setShowSpin(false)
      setTimeout(() => {
        setAccountStatus('done')
        setMessage('')
      }, 5000)
      setAccountStatus('failed')
    }
  }

  return (
    <div className="bg-default min-vh-100 d-flex flex-row align-items-center justify-content-center">
      <SpinnerDefault showSpin={showSpin} />
      <CCard className="floating-card">
        <CCardBody className="d-flex flex-column align-items-center gap-4 pd-5">
          <div className="d-flex flex-column align-items-center gap-2 text-center">
            <img src={logo} height={120} width={120} alt="Logomarca da Scius" />
            <div>{message}</div>
            <div className="text-center w-100" style={{ letterSpacing: '-0.0375em' }}>
              <h3 className="fs-2 fw-bold lh-1">Bem-vindo!</h3>
              <h6 className="fs-6 fw-regular lh-1">Acesse a sua conta</h6>
            </div>
          </div>

          <CForm className="d-flex flex-column gap-4 w-100" onSubmit={onClickLogin}>
            <div className="d-flex flex-column gap-2">
              <div>
                <CFormLabel className="fw-bold" style={{ fontSize: '12px' }}>
                  Email
                </CFormLabel>
                <CInputGroup>
                  <CFormInput
                    placeholder="Digite o seu e-mail"
                    autoComplete="username"
                    onChange={(event) => setEmail(event.target.value)}
                    required
                  />
                </CInputGroup>
              </div>
              <div>
                <CFormLabel className="fw-bold" style={{ fontSize: '12px' }}>
                  Senha
                </CFormLabel>
                <CInputGroup className="mb-0">
                  <CFormInput
                    type="password"
                    placeholder="Digite a sua senha"
                    autoComplete="current-password"
                    onChange={(event) => setPassword(event.target.value)}
                    required
                  />
                </CInputGroup>
              </div>
            </div>

            <div className="row align-items-center">
              <div className="col">
                <CButton
                  className="w-100"
                  color="secondary"
                  style={{ border: '0px' }}
                  onClick={forgotPassword}
                >
                  Esqueceu a senha?
                </CButton>
              </div>
              <div className="col">
                <CButton className="w-100" color="primary" type="submit">
                  Entrar
                </CButton>
              </div>
            </div>
            {/*
                    <CRow>
                      <CCol style={{ fontSize: '14px', textAlign: 'center' }}>
                        Não tem uma conta?{' '}
                        <Link to="/register" style={{ textDecoration: 'none', color: '#17c4dd' }}>
                          Cadastre-se
                        </Link>
                      </CCol>
                    </CRow>
                  */}
          </CForm>
        </CCardBody>
      </CCard>
      {/* <ReCaptcha
        ref={(el) => {
          captchaDemo = el
        }}
        size="invisible"
        data-theme="dark"
        render="explicit"
        sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
        onloadCallback={onLoadRecaptcha}
        verifyCallback={verifyCallback}
      /> */}
    </div>
  )
}

export default Login
